angular.module("digitalLeasing.module").component("estimates", {
  templateUrl: "ng/components/digitalLeasing/financialData/estimates/estimates.view.html",
  bindings: {
    model: "=",
    onEstimatesChange: "&",
    listOfEstimates: "<",
    checkEstimates: "<",
    insurance: "=",
    validateComponentEstimates: '&',
    pianoFinanziario: "=",
    checkEstimatesBis: '<'
  },
  controllerAs: "estimatesCtrl",
  controller: EstimatesController,
});

function EstimatesController($scope, $simulationService) {
  var self = this;
  self.init = true;
  self.$onInit = function () {
    self.totalEstimates = 0;
    self.enabledError = [];
    self.enabledErrorLock = [];
    self.mexError = [];
    self.init = false;
    self.estimatesFixed = {
      selected: self.pianoFinanziario.speseFisse
    }

    checkOrModifyEstimates();
  };

  self.$onChanges = function (changes) {
    if (self.init) {
      return;
    }

    if (changes.listOfEstimates && changes.listOfEstimates.currentValue) {
      if (!self.estimatesFixed.selected) {
        self.model = self.listOfEstimates;

      } else {
        if (!self.model.length) {
          self.model = self.listOfEstimates;
        }
        self.model = updateValidationEstimates();
      }


      calculatedAllEstimates();

    }

    if (changes.checkEstimates && typeof changes.checkEstimates.currentValue != "undefined") {

      checkOrModifyEstimates();

    }
    if (changes.checkEstimatesBis && typeof changes.checkEstimatesBis.currentValue != "undefined") {
      updateSpesaAss();
    }
  };

  self.estimatesChanged = function (name, value, index) {
    self.model[index].importo = value;

    if (self.model[index].id == 'ASS_NO_CONV' || self.model[index].id == 'ASS_CONV') {
      return
    }
    if (typeof self.model[index].importo == 'undefined' || self.model[index].importo == "") {
      self.model[index].importo = 0;
    }
    if (
      self.model[index].importo >
      self.model[index].validations.importo.massimo.valore ||
      self.model[index].importo <
      self.model[index].validations.importo.minimo.valore
    ) {
      if (self.model[index].importo >
        self.model[index].validations.importo.massimo.valore) {
        self.enabledErrorLock[index] = true;
        self.enabledError[index] = false;
        self.mexError[index] = "L'importo è fuori dal range consentito.<br/>Max: " + self.model[index].validations.importo.massimo.valore + ";"
        self.validateComponentEstimates({
          value: false
        });
      } else {
        self.enabledError[index] = true;
        self.enabledErrorLock[index] = false;
        self.mexError[index] = "L'importo è fuori dal range autorizzato.<br/>Min: " + self.model[index].validations.importo.minimo.valore + ";<br/>Max: " + self.model[index].validations.importo.massimo.valore + ";"
        self.validateComponentEstimates({
          value: true
        });
      }

      $scope.formEstimates && $scope.formEstimates["spesa-" + index] &&
        $scope.formEstimates["spesa-" + index].$setValidity(
          "spesa-" + index,
          false
        );
      jQuery("#spesa-" + index).addClass("has-error");
      if (self.model[index].id == 'ASS') {
        self.validateComponentEstimates({
          value: false
        });
      }
    } else {
      self.enabledError[index] = false;
      self.enabledErrorLock[index] = false;
      $scope.formEstimates && $scope.formEstimates["spesa-" + index] &&
        $scope.formEstimates["spesa-" + index].$setValidity(
          "spesa-" + index,
          true
        );
      jQuery("#spesa-" + index).removeClass("has-error");

      self.validateComponentEstimates({
        value: true
      });

    }
    if (self.model[index].id == 'ASS') {
      if (self.model[index].importo <
        self.model[index].validations.importo.consigliato.valore) {
        self.enabledError[index] = true;
        $scope.formEstimates && $scope.formEstimates["spesa-" + index] &&
          $scope.formEstimates["spesa-" + index].$setValidity("spesa-" + index, false);
        jQuery("#spesa-" + index).addClass("has-error");
        self.mexError[index] = "Valore diverso da default: " + self.model[index].validations.importo.consigliato.valore + ", necessaria deroga.<br/> Range di valori ammessi: " + self.model[index].validations.importo.minimo.valore + " - " + self.model[index].validations.importo.massimo.valore;
      }
    }

    self.model[index].importoSpesaCliente =
      ((self.model[index].importo -
        self.model[index].validations.importoRiconoscereAlba.minimo.valore) *
        self.model[index].validations.importoRiconoscereAlbaPerc.consigliato
          .valore) / 100;

    calcTotEstimates();
    validateEstimates();
  };

  var calcTotEstimates = function () {
    self.totalEstimates = 0;

    self.model.forEach(function (currentValue) {
      if (currentValue.id != "ASS_CONV" && currentValue.id != "ASS_NOCONV") {
        self.totalEstimates += currentValue.importoSpesaCliente;
      }
    });

    if (self.totalEstimates < 0) {
      self.totalEstimates = 0;
    }

    self.onEstimatesChange({
      totalEstimates: self.totalEstimates,
    });
  };

  var calculatedAllEstimates = function () {
    self.model.forEach(function (e, index) {
      if (e.id != "ASS_CONV" && e.id != "ASS_NOCONV") {
        e.importoSpesaCliente =
          ((e.importo - e.validations.importoRiconoscereAlba.minimo.valore) *
            e.validations.importoRiconoscereAlbaPerc.consigliato.valore) /
          100;
        var name = 'spesa-' + index;
        self.estimatesChanged(name, e.importo, index);
      }
    });
    calcTotEstimates();
  };

  var checkOrModifyEstimates = function () {
    var control = self.insurance.some(function (element) {
      return element.tipoAssicurazione == "D";
    });

    if (self.model.length <= 0) {
      return;
    }

    if (!control) {
      var indefOfAss = self.model.findIndex(function (e) {
        return e.id == "ASS";
      });

      var indefOfAssConv = self.model.findIndex(function (e) {
        return e.id == "ASS_CONV";
      });

      var visible = self.model[indefOfAss].visible
      if (!self.pianoFinanziario.speseFisse) {
        self.model[indefOfAss] = JSON.parse(JSON.stringify(self.model[indefOfAssConv]));
      } else {
        self.model[indefOfAss].validations = JSON.parse(JSON.stringify(self.model[indefOfAssConv].validations));

      }

      self.model[indefOfAss].id = "ASS";
      self.model[indefOfAss].visible = visible
    } else {
      var indefOfAss = self.model.findIndex(function (e) {
        return e.id == "ASS";
      });

      var indefOfAssNoConv = self.model.findIndex(function (e) {
        return e.id == "ASS_NO_CONV";
      });
      var visible = self.model[indefOfAss].visible
      if (!self.pianoFinanziario.speseFisse && indefOfAss > -1 && indefOfAssNoConv > -1) {
        self.model[indefOfAss] = JSON.parse(JSON.stringify(self.model[indefOfAssNoConv]));
      } else if (indefOfAss > -1 && indefOfAssNoConv > -1) {
        self.model[indefOfAss].validations = JSON.parse(JSON.stringify(self.model[indefOfAssNoConv].validations));
      }
      self.model[indefOfAss].id = "ASS";
      self.model[indefOfAss].visible = visible
    }

    calculatedAllEstimates();
  };

  self.check = function (el) {
    el.selected = !el.selected;

    self.pianoFinanziario.speseFisse = el.selected;
  };

  var validateEstimates = function () {

    var test = self.enabledErrorLock
      .some(function (element) {
        return element == true;
      })

    var testImportoUndefined = self.model.every(function (element) {
      return typeof element.importo != 'undefined'
    })

    if (test || !testImportoUndefined) {
      self.validateComponentEstimates({
        value: false
      });
    } else {
      self.validateComponentEstimates({
        value: true
      });
    }
  }

  var updateValidationEstimates = function () {
    return self.listOfEstimates.map(function (element) {
      var indexNew = self.model.findIndex(x => { return x.id == element.id })
      return {
        validations: element.validations,
        description: element.description,
        id: element.id,
        isEditable: element.isEditable,
        provenienza: element.provenienza,
        visible: element.visible,
        importoSpesaCliente: self.model[indexNew].importoSpesaCliente,
        importo: self.model[indexNew].importo,
        importoRiconosciuto: element.importoRiconosciuto
      }
    })
  }


  var updateSpesaAss = () => {
    var indefOfAss = self.model.findIndex(function (e) {
      return e.id == "ASS";
    });
    var codServizio = self.insurance.map(x => {
      return x.id
    })
    $simulationService.updateSpesaAss(codServizio, self.model[indefOfAss])
      .then((response) => {
        if (!self.pianoFinanziario.speseFisse) {
          self.model[indefOfAss] = response.spesa
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
}